import React from 'react';
import DatePicker from 'react-datepicker';
import { TimeInputLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import useUiTheme from '../../../uiTheme';
import ShadcnTimeInputLayout from './ShadcnTimeInputLayout';

function LegacyTimeInputLayout(props: TimeInputLayoutProps) {
  const uiTheme = useUiTheme();

  const value = props.value || null;

  return (
    <uiTheme.forms.BaseInputLayout label={props.label} name={props.name} errors={props.errors}>
      <DatePicker
        placeholderText={props.placeholder}
        selected={value}
        disabled={props.isDisabled}
        onChange={(date: Date) => {
          props.onChangeCallback({
            target: {
              value: date,
            },
          });
        }}
        showTimeSelect
        showTimeSelectOnly
        dateFormat="hh:mm aa"
      />
    </uiTheme.forms.BaseInputLayout>
  );
}

function TimeInputLayout(props: TimeInputLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTimeInputLayout {...props} />;
  } else {
    return <LegacyTimeInputLayout {...props} />;
  }
}

export default TimeInputLayout;
